var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4814 7.05571C19.4814 6.36255 19.4814 6.01598 19.4053 5.73162C19.1985 4.95996 18.5957 4.35724 17.8242 4.15047C17.0754 3.94984 15.9246 3.94984 15.1758 4.15047C14.4042 4.35724 13.8015 4.95996 13.5948 5.73162C13.5186 6.01598 13.5186 6.36255 13.5186 7.05571C13.5186 8.46118 13.5186 12.1453 13.082 12.582C12.6453 13.0186 8.96118 13.0186 7.55571 13.0186C6.86255 13.0186 6.51598 13.0186 6.23162 13.0948C5.45996 13.3015 4.85724 13.9043 4.65047 14.6759C4.44984 15.4247 4.44984 16.5753 4.65047 17.3241C4.85724 18.0957 5.45996 18.6985 6.23162 18.9052C6.51598 18.9815 6.86255 18.9815 7.55571 18.9815C8.96118 18.9815 12.6453 18.9815 13.082 19.418C13.5186 19.8547 13.5186 20.5573 13.5186 21.9628C13.5186 22.656 13.5186 25.9841 13.5948 26.2684C13.8015 27.04 14.4042 27.6428 15.1758 27.8495C15.9246 28.0501 17.0754 28.0501 17.8242 27.8495C18.5957 27.6428 19.1985 27.04 19.4053 26.2684C19.4814 25.9841 19.4814 22.656 19.4814 21.9628C19.4814 20.5573 19.4814 19.8547 19.9181 19.418C20.3546 18.9815 24.0388 18.9815 25.4444 18.9815C26.1374 18.9815 26.4841 18.9815 26.7685 18.9052C27.5401 18.6985 28.1428 18.0957 28.3496 17.3241C28.5502 16.5753 28.5502 15.4247 28.3496 14.6759C28.1428 13.9043 27.5401 13.3015 26.7685 13.0948C26.4841 13.0186 26.1374 13.0186 25.4444 13.0186C24.0388 13.0186 20.3546 13.0186 19.9181 12.582C19.4814 12.1453 19.4814 8.46118 19.4814 7.05571Z",
    stroke: "#F7FEFA",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLight);
export default __webpack_public_path__ + "static/media/add-light.bc83fa5e7578f70de968992f001ebb14.svg";
export { ForwardRef as ReactComponent };